// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"58ff7fba","160":"d0eb52f1","193":"d6ea7ab5","244":"5e1d8aac","600":"04a162ce","640":"16939f62","728":"f80a4137","786":"86ed0709"}[chunkId] + ".chunk.js";
};